<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <li>
        <router-link
          to="/gpao/dashboard"
          v-slot="{ href, navigate, isActive, isExactActive }"
          custom
          exact
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-speedometer"></i>
            <span>Dashboard</span>
          </a>
        </router-link>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="ion ion-md-cube"></i>
          <span> Articles & Stocks</span>
        </a>
        <ul class="sub-menu" aria-expanded="true">
          <li>
            <router-link
              tag="a"
              to="/gpao/article-stock/article"
              class="side-nav-link-ref"
            >
              <i class="far fa-circle"></i>Articles</router-link
            >
          </li>

          <li>
            <router-link
              tag="a"
              to="/gpao/article-stock/transfert"
              class="side-nav-link-ref"
              ><i class="far fa-circle"></i>Transferts de stocks</router-link
            >
          </li>
          <li>
            <router-link
              tag="a"
              to="/gpao/article-stock/stock"
              class="side-nav-link-ref"
              exact
              ><i class="far fa-circle"></i>Stocks</router-link
            >
          </li>
          <li>
            <router-link
              tag="a"
              to="/gpao/article-stock/mouvement"
              class="side-nav-link-ref"
              ><i class="far fa-circle"></i>Mouvements</router-link
            >
          </li>
        </ul>
      </li>

      <li>
        <router-link
          to="/gpao/demande-transfert"
          v-slot="{ href, navigate, isActive, isExactActive }"
          class="side-nav-link-ref"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Demandes de transfert</span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link
          to="/gpao/transfert-stock"
          v-slot="{ href, navigate, isActive, isExactActive }"
          class="side-nav-link-ref"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Transfert de stock</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          to="/gpao/poste-charge"
          v-slot="{ href, navigate, isActive, isExactActive }"
          class="side-nav-link-ref"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Postes de charge</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          to="/gpao/checklist"
          v-slot="{ href, navigate, isActive, isExactActive }"
          class="side-nav-link-ref"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Checklists</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          to="/gpao/nomenclature"
          v-slot="{ href, navigate, isActive, isExactActive }"
          class="side-nav-link-ref"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Nomenclatures</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          to="/gpao/of"
          v-slot="{ href, navigate, isActive, isExactActive }"
          class="side-nav-link-ref"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>OFs</span>
          </a>
        </router-link>
      </li>
      <!--li>
        <router-link
          to="/gpao/suivi-of"
          v-slot="{ href, navigate, isActive, isExactActive }"
          class="side-nav-link-ref"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="[isActive && 'mm-active', isExactActive && 'exact-active']"
          >
            <i class="ion ion-md-cube"></i>
            <span>Suivi des OFs</span>
          </a>
        </router-link>
      </li-->
    </ul>
  </div>
  <!-- Sidebar -->
</template>
<script>
import MetisMenu from 'metismenujs/dist/metismenujs';
export default {
  components: {},
  mounted() {
    new MetisMenu('#side-menu');
  },
  methods: {},
};
</script>
<style scoped>
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid #e7eaed;
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-header + .list-group .list-group-item:first-child {
  border-top: 0;
}

.card-custom-primary {
  color: black;
  background-color: #c2a533a1;
}
.list-group-item-action {
  color: black;
}

#side-bar a:active {
  color: #ad932f !important;
}
</style>
